<div
        *ngIf="!this.rotaAtual.includes('entregabenz')"
        class="position-sticky d-lg-none bg-info text-center  text-primary pt-1 pb-1h"
     style="bottom: 0;">
  <div class="row no-gutters">
    <div class="col-4">
      <a (click)="toggleFab();"
         class="d-flex flex-column align-items-center fs-14 border-right border-primary"
         aria-label="Concessionárias"
         title="Concessionárias">
        <img src="/assets/images/icons/ic-whatsapp.svg"
             loading="lazy"
             width="18"
             height="18"
             class="mb-0h"
             alt="Concessionárias">
        Agendamento
      </a>
    </div>
    <div class="col-4">
      <a routerLink="/concessionarias"
         class="d-flex flex-column align-items-center fs-14 border-right border-primary"
         aria-label="Concessionárias"
         title="Concessionárias">
        <img src="/assets/images/icons/ic-concessionaires.svg"
             loading="lazy"
             width="18"
             height="18"
             class="mb-0h"
             alt="Concessionárias">
        Concessionárias
      </a>
    </div>
    <div class="col-4">
      <a (click)="abrirModal()"
         role="button"
         data-bs-toggle="modal"
         data-bs-target="#modalContact"
         class="d-flex flex-column align-items-center fs-14"
         aria-label="Fale Conosco"
         title="Fale Conosco">
        <img src="/assets/images/icons/ic-talk-to-us.svg"
             loading="lazy"
             width="18"
             height="18"
             class="mb-0h"
             alt="Fale Conosco">
        Fale Conosco
      </a>
    </div>
  </div>
</div>
<app-modal-contato #modalContato
                   codigoTemplate="contato"></app-modal-contato>
<button id="js-fab-cta-contacts"
        aria-label="Atendimentos"
        data-fmd-datalayer-usage="default"
        data-fmd-datalayer-action="whatsapp"
        data-fmd-datalayer-destination="in-page"
        [ngClass]="{
          'd-none d-lg-flex': !rotaAtual.includes('entregabenz'),
          'd-flex': rotaAtual.includes('entregabenz')
        }"
        class="btn fab-btn no-focus align-items-center"
        (click)="toggleFab();">
  <img src="assets/images/icons/ic-whatsapp.svg"
       class="img-fluid me-lg-1 ic-steps"
       alt="Veja nossas opções para Contatos Rodobens"
       title="Veja nossas opções para Contato"
       loading="lazy"
       width="25"
       height="24">
    <span class="d-none d-lg-inline">Faça seu agendamento</span>
</button>
<div id="js-fab-box-contacts" class="fab-box" [ngClass]="fabActive == true || this.router.url.includes('?agendamento=aberto') ? 'fab-box-active' : ''">
    <a (click)="toggleFab();" class="ms-auto d-block d-lg-none text-end" role="button">
        <img src="/assets/images/icons/ic-close.svg" loading="lazy" width="14" height="23" class="img-fluid" alt="Ícone de Menu">
    </a>
    <h3 class="fab-box-title text-info">
        Faça seu agendamento pelo WhatsApp
    </h3>
    <p class="fab-box-description mb-1h">
        Selecione a concessionária para realizar o agendamento da sua revisão.
    </p>
    <div class="mb-1 mb-1h">
        <ng-select [items]="atendimentos" bindLabel="nome" bindValue="id" [(ngModel)]="idConcessionaria"
            placeholder="Concessionária" notFoundText="Nenhuma concessionária disponível">
        </ng-select>
    </div>
    <button type="button" (click)="startService();" class="btn btn-whatsapp w-100 mb-1h">
        Iniciar conversa
    </button>
    <p class="text-center" style="line-height: 18px">
        Horário de atendimento:
        <strong class="d-block">
            08:00 às 18:00 horas
        </strong>
    </p>
</div>
<footer id="footer" class="bg-dark text-primary pt-sm-79px pb-sm-50px pt-lg-2h pb-lg-30px">
  <div class="container">
    <div class="px-sm-1h px-lg-0">
    <div class="mb-3 mb-sm-61px mb-lg-2q">
      <h3 class="mb-sm-57px mb-lg-2q bold-text s-pro-text text-uppercase fs-14 fs-sm-35 fs-lg-14 ls-2">
        Mundo Mercedes-Benz
      </h3>
      <div class="row">
        <div class="col-lg" *ngFor="let link of links; let last = last">
          <ng-container *ngIf="!!link.external; else internalLink">
            <a class="d-block mb-1 mb-lg-0 bold-text text-reset text-uppercase fs-11 fs-sm-30 fs-lg-11 ls-2"
               [attr.aria-label]="link.label"
               [attr.title]="link.label"
               *ngIf="link.external"
               [href]="link.href"
               target="_blank"
               rel="noopener">
              {{ link.title }}
            </a>
          </ng-container>
          <ng-template #internalLink>
          <a class="d-block mb-1 mb-lg-0 bold-text text-reset text-uppercase fs-11 fs-sm-30 fs-lg-11 ls-2"
             [attr.aria-label]="link.label"
             [attr.title]="link.label"
             [routerLink]="link.routerLink"
             [class.mb-sm-0]="last">
            {{ link.title }}
          </a>
        </ng-template>
      </div>
      </div>
    </div>
    <hr class="mb-3 mb-sm-3q mb-lg-45px border-0 border-top" style="border-color: #313131">
    <div class="mb-3 mb-lg-45px">
      <h3 class="mb-2h mb-sm-5 mb-lg-2q bold-text s-pro-text text-uppercase fs-14 fs-sm-35 fs-lg-14 ls-2">
        Redes Sociais
      </h3>
      <div class="row gy-sm-70px gx-lg-50px">
        <div class="col-lg-auto">
          <a class="d-block mb-1 mb-sm-0 text-light s-demi-text fs-14 fs-sm-38 fs-lg-14 text-gray-tint-2"
             aria-label="Facebook"
             title="Facebook"
             href="https://www.facebook.com/rodobensveiculoscomerciais/"
             target="_blank"
             rel="noopener">
            <img src="/assets/images/icons/ic-facebook.svg"
                 loading="lazy"
                 width="18"
                 height="18"
                 class="me-0hq me-sm-45px me-lg-0hq img-social-media"
                 alt="Facebook">
            Facebook
          </a>
        </div>
        <div class="col-lg-auto">
          <a class="d-block mb-1 mb-sm-0 text-light s-demi-text fs-14 fs-sm-38 fs-lg-14 text-gray-tint-2"
             aria-label="Instagram"
             title="Instagram"
             href="https://www.instagram.com/rodobensveiculoscomerciais/"
             target="_blank"
             rel="noopener">
            <img src="/assets/images/icons/ic-instagram.svg"
                 loading="lazy"
                 width="18"
                 height="18"
                 class="me-0hq me-sm-45px me-lg-0hq img-social-media"
                 alt="Instagram">
            Instagram
          </a>
        </div>
        <div class="col-lg-auto">
          <a class="d-block mb-1 mb-sm-0 text-light s-demi-text fs-14 fs-sm-38 fs-lg-14 text-gray-tint-2"
             aria-label="YouTube"
             title="YouTube"
             href="https://www.youtube.com/user/RodobensOficial"
             target="_blank"
             rel="noopener">
            <img src="/assets/images/icons/ic-youtube.svg"
                 loading="lazy"
                 width="18"
                 height="18"
                 class="me-0hq me-sm-45px me-lg-0hq img-social-media"
                 alt="YouTube">
            YouTube
          </a>
        </div>
      </div>
    </div>
    <hr class="mb-3 my-sm-65px mt-lg-2 mb-lg-30px border-0 border-top" style="border-color: #313131">
    <div class="row justify-content-lg-between">
      <div class="col-lg-auto">
        <div class="mb-2 mb-sm-0 fs-14 fs-sm-35 fs-lg-14">
          <span class="s-demi-text">© {{ currentYear }} Rodobens</span>
          <span class="d-none d-lg-inline-block mx-1">
            |
          </span>
          <a [href]="politicaPrivacidade.url"
             target="_blank"
             rel="noopener"
             class="d-block d-lg-inline-block text-light light-text my-sm-75px my-lg-0"
             aria-label="Politica de Privacidade"
             title="Politica de Privacidade">
            Politica de Privacidade
          </a>
          <span class="d-none d-lg-inline-block mx-1">
            |
          </span>
          <a [href]="segurancaCibernetica.url"
             target="_blank"
             rel="noopener"
             class="d-block d-lg-inline-block text-light light-text mb-sm-75px mb-lg-0"
             aria-label="Política de Segurança Cibernética"
             title="Política de Segurança Cibernética">
            Política de Segurança Cibernética
          </a>
          <span class="d-none d-lg-inline-block mx-1">
            |
          </span>
          <a [href]="codigoEtica.url"
             target="_blank"
             rel="noopener"
             class="d-block d-lg-inline-block text-light light-text mb-sm-75px mb-lg-0"
             aria-label="Código de Ética"
             title="Código de Ética">
            Código de Ética
          </a>
          <span class="d-none d-lg-inline-block mx-1">
            |
          </span>
          <a href="https://canaldedenuncia.com.br/empresasrodobens/"
             target="_blank"
             rel="noopener"
             class="d-block d-lg-inline-block text-light light-text mb-sm-75px mb-lg-0"
             aria-label="Canal de Denúncia"
             title="Canal de Denúncia">
            Canal de Denúncia
          </a>
          <span class="d-none d-lg-inline-block mx-1">
            |
          </span>
          <a href="http://www.procon.rj.gov.br/"
             target="_blank"
             rel="noopener"
             class="d-block d-lg-inline-block text-light light-text mb-sm-75px mb-lg-0"
             aria-label="Procon RJ"
             title="Procon RJ">
            Procon RJ
          </a>
          <span class="d-none d-lg-inline-block mx-1">
            |
          </span>
          <a class="d-block d-lg-inline-block text-light light-text ot-sdk-show-settings"
             aria-label="Gerenciar cookies"
             title="Gerenciar cookies"
             id="ot-sdk-btn">Gerenciar cookies
          </a>
        </div>
      </div>
      <hr class="d-none d-sm-block d-lg-none mb-sm-2h mt-sm-70px border-0 border-top" style="border-color: #313131">
      <div class="col-lg-auto">
        <a class="d-block mb-lg-0 text-light fs-14 fs-sm-75 fs-lg-14"
           aria-label="Voltar para o topo"
           title="Voltar para o topo"
           (click)="voltarTopo()">
          <img src="/assets/images/icons/ic-back-to-top.svg"
               loading="lazy"
               width="13"
               height="13"
               class="me-0q img-arrow-up"
               alt="Voltar para o topo">
          Voltar para o topo
        </a>
      </div>
    </div>
    </div>
  </div>
</footer>
